import { AxiosResponse } from 'axios';
import React, { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'
import { APIToFetchInvoiceDetail } from '../../../../service/api-service';
import { APIResponseEntity } from '../../../../interface/api-responce';
import { toast } from 'react-toastify';
import { toastOptObj } from '../../../../utils/constants';
import Loader from '../../../../components/loader';
import { IsStringNullEmptyOrUndefined } from '../../../../utils/null-check';
import { ViewInvoiceDetailEntity } from '../../../../interface/invoice';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';

function ViewInvoiceDetails() {

    /* states & hooks*/
    const [isLoading, setIsLoading] = useState<boolean>(false);

    const [invoiceDetail, setInvoiceDetail] = useState<ViewInvoiceDetailEntity | null>(null);

    const { id } = useParams();

    const navigate = useNavigate();

    /* functions */
    const handleFetchInvoiceDetail = async (id: string) => {
        setIsLoading(true);
        try {
            const resp: AxiosResponse = await APIToFetchInvoiceDetail(id);

            if (!resp || (resp && (resp.status !== 200 || !resp.data))) {
                console.log({ resp });
                return;
            }

            const apiRespPayload: APIResponseEntity = resp.data;

            if (apiRespPayload.statusCode !== 200 || !apiRespPayload.data) {
                toast.error(apiRespPayload.message || apiRespPayload.errorMsg,
                    { ...toastOptObj });
                return;
            }

            setInvoiceDetail(apiRespPayload.data.invoiceDetail);
        } catch (err) {
            console.log(err)
        }
        finally {
            setIsLoading(false);
        }
    }

    const AddressInformationBlock = (type: "From" | "To", subType: "Dispatch From" | "Ship To", details: ViewInvoiceDetailEntity["fromAddress"]) => {
        const lastLine = [details.city, details.state, details.pinCode].filter((item) => !IsStringNullEmptyOrUndefined(item)).join(", ")
        return (
            <div className="col-md-6 col-12">
                <h4 className='fw-bold'>{type} </h4>
                <div className="col-sm-12 col-md-12">
                    <span className='text-muted'> GSTIN:</span>
                    <span className='fw-medium'> {details && details.gstIn} </span>
                </div>
                <div className="col-sm-12 col-md-12 mt-2">
                    <span className='fw-medium'> {details && details.name} </span>
                </div>
                <div className="col-sm-12 col-md-12 mt-2">
                    <span className='fw-medium'> {details && details.state} </span>
                </div>

                <div className="col-sm-12 col-md-12 mt-3">
                    <span className='text-muted'> {subType}</span>
                </div>
                <div className="col-sm-12 col-md-12 mt-2">
                    <span className='fw-medium'> {details && details.address1} </span>
                </div>  <div className="col-sm-12 col-md-12 mt-2">
                    <span className='fw-medium'> {details && details.address2} </span>
                </div>  <div className="col-sm-12 col-md-12 mt-2">
                    <span className='fw-medium'> {lastLine} </span>
                </div>
            </div>
        )
    }

    /* effects */
    useEffect(() => {
        if (id && !IsStringNullEmptyOrUndefined(id)) {
            handleFetchInvoiceDetail(id);
        }
    }, [id])

    return (
        <>
            <Loader isLoading={isLoading} />
            <div className="content-wrapper">
                <div>
                    <div className='col-lg-12 col-md-12 mb-3'>
                        <div className="card card-rounded">
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-12">
                                        <h4 className="card-title">E-Way Bill Details</h4>

                                        <div className="row">
                                            <div className="col-sm-12 col-md-4 col-lg-3">
                                                <span className='fw-bold'>E-Way Bill No</span>
                                                <p className='text-muted'>{invoiceDetail && invoiceDetail.eWayBillNo} </p>
                                            </div>
                                            <div className="col-sm-12 col-md-4 col-lg-3">
                                                <span className='fw-bold'>Generated Date</span>
                                                <p className='text-muted'>{invoiceDetail && invoiceDetail.generatedDate} </p>
                                            </div>
                                            <div className="col-sm-12 col-md-4 col-lg-3">
                                                <span className='fw-bold'>Generated By</span>
                                                <p className='text-muted'>{invoiceDetail && invoiceDetail.generatedBy || "-"}</p>
                                            </div>
                                            <div className="col-sm-12 col-md-4 col-lg-3">
                                                <span className='fw-bold'>Valid Upto</span>
                                                <p className='text-muted'>{invoiceDetail && invoiceDetail.validUpto} </p>
                                            </div>
                                            <div className="col-sm-12 col-md-4 col-lg-3">
                                                <span className='fw-bold'>Approx Distance</span>
                                                <p className='text-muted'>{invoiceDetail && invoiceDetail.approxDistance || "0"}km </p>
                                            </div>
                                            <div className="col-sm-12 col-md-4 col-lg-3">
                                                <span className='fw-bold'>Type</span>
                                                <p className='text-muted'>{invoiceDetail && invoiceDetail.type} </p>
                                            </div>
                                            <div className="col-sm-12 col-md-4 col-lg-3">
                                                <span className='fw-bold'>Document Details</span>
                                                <p className='text-muted'>{invoiceDetail && invoiceDetail.documentDetail}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='col-lg-12 col-md-12 mb-3'>
                        <div className="card card-rounded">
                            <div className="card-body">
                                <h4 className="card-title">Address Details</h4>
                                <div className="row consign-block">
                                    {invoiceDetail && AddressInformationBlock("From", "Dispatch From", invoiceDetail.fromAddress)}
                                    {invoiceDetail && AddressInformationBlock("To", "Ship To", invoiceDetail.toAddress)}
                                </div>

                            </div>
                            <div className="card-body">
                                <h4 className="card-title">Goods Details</h4>
                                {
                                    invoiceDetail && (
                                        <DataTable value={invoiceDetail.items}>
                                            <Column field='serNo' header="ITEM NO" />
                                            <Column field='description' header="DESCRIPTION" />
                                            <Column field='hsnCode' header="HSN CODE" />
                                            <Column field='quantity' header="QUANTITY" />
                                            <Column field='unit' header="UNIT" />
                                            <Column field='taxAbleValue' header="ASSESSABLE AMOUNT" />
                                            <Column field='cgst' header="CGST RATE" />
                                            <Column field='sgst' header="SGST RATE" />
                                            <Column field='igst' header="IGST RATE" />
                                        </DataTable>
                                    )
                                }

                                <div className="row pt-5">
                                    <div className="col-sm-12 col-md-4 col-lg-3">
                                        <span className='fw-bold'>Assessable Amount</span>
                                        <p className='text-muted'>₹ {invoiceDetail ? invoiceDetail.totalTaxableVal : 0} </p>
                                    </div>
                                    <div className="col-sm-12 col-md-4 col-lg-3">
                                        <span className='fw-bold'>CGST Amount</span>
                                        <p className='text-muted'>₹ {invoiceDetail ? invoiceDetail.cgstAmount : 0} </p>
                                    </div>
                                    <div className="col-sm-12 col-md-4 col-lg-3">
                                        <span className='fw-bold'>SGST Amount</span>
                                        <p className='text-muted'>₹ {invoiceDetail ? invoiceDetail.sgstAmount : 0}</p>
                                    </div>
                                    <div className="col-sm-12 col-md-4 col-lg-3">
                                        <span className='fw-bold'>IGST Amount</span>
                                        <p className='text-muted'>₹ {invoiceDetail ? invoiceDetail.igstAmount : 0} </p>
                                    </div>
                                    <div className="col-sm-12 col-md-4 col-lg-3">
                                        <span className='fw-bold'>Total Amount</span>
                                        <p className='text-muted'>₹ {invoiceDetail ? invoiceDetail.totalInvAmt : 0} </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-12 col-md-12 mb-3">
                        <div className="card card-rounded">
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-12">
                                        <h4 className="card-title">Transportation Details</h4>

                                        <div className="row">
                                            <div className="col-sm-12 col-md-4 col-lg-3">
                                                <span className='fw-bold'>Transporter ID</span>
                                                <p className='text-muted'>{invoiceDetail && invoiceDetail.transportationDetail && invoiceDetail.transportationDetail.id} </p>
                                            </div>
                                            <div className="col-sm-12 col-md-4 col-lg-3">
                                                <span className='fw-bold'>Transporter Name</span>
                                                <p className='text-muted'>{invoiceDetail && invoiceDetail.transportationDetail && invoiceDetail.transportationDetail.name} </p>
                                            </div>
                                            <div className="col-sm-12 col-md-4 col-lg-3">
                                                <span className='fw-bold'>Transporter Doc</span>
                                                <p className='text-muted'>{"-"} </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-12 col-md-12 mb-3">
                        <div className="card card-rounded">
                            <div className="card-body">
                                <div className="row">
                                    <div className="col-12">
                                        <h4 className="card-title">Vehicle Details</h4>

                                        <div className="row">
                                            <div className="col-sm-12 col-md-4 col-lg-3">
                                                <span className='fw-bold'>Vehicle No</span>
                                                <p className='text-muted'>{invoiceDetail && invoiceDetail.vehicleDetail && invoiceDetail.vehicleDetail.vehicle} </p>
                                            </div>
                                            <div className="col-sm-12 col-md-4 col-lg-3">
                                                <span className='fw-bold'>Vehicle Mode</span>
                                                <p className='text-muted'>{invoiceDetail && invoiceDetail.vehicleDetail && invoiceDetail.vehicleDetail.mode} </p>
                                            </div>
                                            <div className="col-sm-12 col-md-4 col-lg-3">
                                                <span className='fw-bold'>Vehicle From</span>
                                                <p className='text-muted'>{invoiceDetail && invoiceDetail.vehicleDetail && invoiceDetail.vehicleDetail.from} </p>
                                            </div>
                                            <div className="col-sm-12 col-md-4 col-lg-3">
                                                <span className='fw-bold'>Vehicle Entered Date</span>
                                                <p className='text-muted'>{invoiceDetail && invoiceDetail.vehicleDetail && invoiceDetail.vehicleDetail.enteredDate} </p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className='col-lg-12 col-md-12 mb-3'>
                        <button className='btn btn-primary' onClick={() => navigate("/transactions/invoices", { replace: true })}>Back</button>
                    </div>
                </div>
            </div>
        </>
    )
}

export default ViewInvoiceDetails